import {
  Button,
  Card,
  Empty,
  Input,
  Spin,
  Table,
  Tree,
  TableColumnsType,
  TableProps,
  message,
} from "antd";
import "../styles.scss";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { TableRowSelection } from "antd/es/table/interface";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import API from "../../../../config/api";
import { GET } from "../../../../utils/apiCall";
import { useNavigate } from "react-router-dom";

// const treeData = [{
//     title: 'Example Sub-Model Element Collection',
//     key: '0-0',
//     children: [{
//       title: 'Example Sub-Model Element Collection',
//       key: '0-0-0',
//       children: [
//         { title: 'Example Sub-Model Element Collection', key: '0-0-0-0' },
//         { title: 'Example Sub-Model Element Collection', key: '0-0-0-1' },
//         { title: 'Example Sub-Model Element Collection', key: '0-0-0-2' },
//       ],
//     }, {
//       title: 'Example Sub-Model Element Collection',
//       key: '0-0-1',
//       children: [
//         { title: 'Example Sub-Model Element Collection', key: '0-0-1-0' },
//         { title: 'Example Sub-Model Element Collection', key: '0-0-1-1' },
//         { title: 'Example Sub-Model Element Collection', key: '0-0-1-2' },
//       ],
//     }, {
//       title: 'Example Sub-Model Element Collection',
//       key: '0-0-2',
//     }],
//   }, {
//     title: 'Example Sub-Model Element Collection',
//     key: '0-1',
//     children: [
//       { title: 'Example Sub-Model Element Collection', key: '0-1-0-0' },
//       { title: 'Example Sub-Model Element Collection', key: '0-1-0-1' },
//       { title: 'Example Sub-Model Element Collection', key: '0-1-0-2' },
//     ],
//   }, {
//     title: 'Example Sub-Model Element Collection',
//     key: '0-2',
//   }];

interface DataType {
  id: React.Key; // Typically, this will be a unique identifier (e.g., a string or number)
  id_short: string;
  name: string;
  kind: { name: string }; // 'kind' is an object with a 'name' property
  category: { name: string }; // 'category' is an object with a 'name' property
  supplier: { name: string }; // 'supplier' is an object with a 'name' property
  derived_from: { name: string } | null; // 'derived_from' is an object with a 'name' property
  parent: { name: string } | null; // 'parent' is an object with a 'name' property
}

const AssetFilter = (props: any) => {
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  console.log("props?.data", props?.data);
  const [selectionType, setSelectionType] = useState<"checkbox" | "radio">(
    "radio"
  );
  const [expandedRows, setExpandedRows] = useState<string[]>([]);

  // const [expandedKeys, setExpandedKeys] = useState([]);
  // const [checkedKeys, setCheckedKeys] = useState([]);
  // const [selectedKeys, setSelectedKeys] = useState([]);
  // const [autoExpandParent, setAutoExpandParent] = useState(true);
  // const [treeData, setTreeData] = useState([]);

  // useEffect(() => {
  //   if (props?.data?.length) {
  //     const formattedData = props.data.map((item: any) => ({
  //       title: item.id_short,
  //       key: item.documentId,
  //     }));
  //     setTreeData(formattedData);
  //   }
  // }, [props.data]);

  // const onExpand = (expandedKeysValue: any) => {
  //   setExpandedKeys(expandedKeysValue);
  //   setAutoExpandParent(false);
  // };

  // const onCheck = (checkedKeysValue: any) => {
  //   setCheckedKeys(checkedKeysValue);
  // };

  // const onSelect = (selectedKeysValue: any, info: any) => {
  //   setSelectedKeys(selectedKeysValue);
  // };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleNameClick = async (id: any) => {
    try {
      const encodedId = btoa(id);
      let url = `${API.DIGITALTWIN_URL}${API.GET_TWIN}/${encodedId}`;
      const response: any = await GET(url);
      if (response?.id) {
        navigate(`/auth/DgTwinDetails/${encodedId}`);
      } else {
        message.error("No data found");
      }
    } catch (error) {
      message.error("No data found");
    }
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id_short",
      width: "30%",
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "15%",
    },
    {
      title: "Kind",
      dataIndex: "kind",
      width: "10%",
      render: (data: any) => data?.name,
    },
    {
      title: "Category",
      dataIndex: "category",
      width: "10%",
      render: (data: any) => data?.name,
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      width: "15%",
      render: (data: any) => data?.name,
    },
    {
      title: "Derived From",
      dataIndex: "derived_from",
      width: "20%",
      render: (data: any) => data?.name,
    },
    // {
    //   title: "Parent",
    //   dataIndex: "parent",
    //   render:(data:any) =>(
    //     data?.name
    //   )
    // },
  ];
  const columns2: TableColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id_short",
      width: "28%",
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "15%",
    },
    {
      title: "Kind",
      dataIndex: "kind",
      width: "10%",
      render: (data: any) => data?.name,
    },
    {
      title: "Category",
      dataIndex: "category",
      width: "10%",
      render: (data: any) => data?.name,
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      width: "15%",
      render: (data: any) => data?.name,
    },
    {
      title: "Derived From",
      dataIndex: "derived_from",
      width: "20%",
      render: (data: any) => data?.name,
    },
    // {
    //   title: "Parent",
    //   dataIndex: "parent",
    //   render:(data:any) =>(
    //     data?.name
    //   )
    // },
  ];

  const rowSelection: TableProps<any>["rowSelection"] = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      if (selectedRowKeys.length > 1) {
        const lastSelectedKey = selectedRowKeys[selectedRowKeys.length - 1];
        setSelectedRowKeys([lastSelectedKey]);
      } else {
        setSelectedRowKeys(selectedRowKeys);
      }
      console.log(
        "Selected Row Keys:",
        selectedRowKeys,
        "Selected Rows:",
        selectedRows
      );
    },
    getCheckboxProps: (record: DataType) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  const handleExpand = (expanded: boolean, record: any) => {
    const key = record.id;
    setExpandedRows(
      expanded
        ? [...expandedRows, key]
        : expandedRows.filter((k) => {
            return k !== key;
          })
    );
  };

  const renderExpandedRow = (record: any) => {
    if (!record.child || !record.child.length) {
      return <p>No child records</p>;
    }

    return (
      <Table
        rowSelection={{ type: selectionType, ...rowSelection }}
        columns={columns2}
        dataSource={record.child}
        rowKey="id"
        pagination={false}
        expandable={{
          expandedRowRender: renderExpandedRow,
          expandIcon: ({ expanded, onExpand, record }) =>
            record?.child?.length > 0 ? (
              expanded ? (
                <DownOutlined onClick={(e) => onExpand(record, e)} />
              ) : (
                <RightOutlined onClick={(e) => onExpand(record, e)} />
              )
            ) : null,
          // expandedRowRender: renderExpandedRow ,
        }}
        showHeader={false}
      />
    );
  };

  return (
    <Card className="graph-view-container">
      <Row className="search-card-heading pb-3">
        <Col>
          <text className="search-card-heading-text">Digital Twins</text>
        </Col>
        <Col className="d-flex justify-content-end ">
          <Input
            style={{ borderRadius: 100 }}
            placeholder="Search here to filter out the result"
            onChange={(e) => {
              props?.search(e.target.value);
            }}
          />
        </Col>
        <Col className="d-flex justify-content-end  gap-2">
          <Button>Add Sensor</Button>
          <Button
            type="primary"
            onClick={() => {
              props?.replacesensor();
            }}
          >
            Replace Sensor
          </Button>
        </Col>
      </Row>
      {/* {props?.loading ? (
        <div style={{height:"200px"}} className="d-flex align-items-center justify-content-center w-100">
          <Spin spinning={props?.loading} />
        </div>
      ) : props?.data?.length ? (
        <Tree
          checkable
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          onCheck={onCheck}
          checkedKeys={checkedKeys}
          onSelect={onSelect}
          selectedKeys={selectedKeys}
          treeData={treeData}
          className="custom-tree"
        />
      ) : (
        <Empty />
      )} */}
      <Table<DataType>
        rowSelection={{ type: selectionType, ...rowSelection }}
        columns={columns}
        loading={props?.loading}
        rowKey="id"
        dataSource={props?.data}
        scroll={{ x: 1000 }}
        expandable={{
          expandedRowKeys: expandedRows,
          onExpand: handleExpand,
          expandIcon: ({ expanded, onExpand, record }: any) =>
            record?.child?.length > 0 ? (
              expanded ? (
                <DownOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                />
              ) : (
                <RightOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                />
              )
            ) : null,
          expandedRowRender: renderExpandedRow,
        }}
        pagination={{
          current: props?.meta?.pagination?.page,
          pageSize: props?.meta?.pagination?.pageSize,
          total: props?.meta?.pagination?.total,
          onChange: (page, pageSize) => {
            props.onPageChange(page, pageSize);
          },
        }}
        onRow={(record) => ({
          onClick: () => handleNameClick(record?.id_short),
        })}
      />
    </Card>
  );
};

export default AssetFilter;
